import { useQuery } from "@tanstack/react-query";
import { getTypeOfServices } from "../actions/getTypeOfService";

export const useTypeOfService = ({ categoryType }) => {
  return useQuery({
    queryKey: ["type-of-services", categoryType],
    queryFn: () => getTypeOfServices({ categoryType }),
    enabled: !!categoryType,
  });
};
